import Header from "./components/Header.jsx";
import Footer from "./components/Footer.jsx";
import FloatingWhatsApp from "./components/FloatingWhatsApp.jsx";
import SEO from "./components/SEO.jsx";
import Home from "./pages/Home.jsx";
import About from "./pages/About.jsx";
import Products from "./pages/Products.jsx";
import Applications from "./pages/Applications.jsx";
import ExportSourcing from "./pages/ExportSourcing.jsx";
import Contact from "./pages/Contact.jsx";
import { normalizePath } from "./data/seo.js";
import { withoutBase } from "./utils/sitePaths.js";

const pageComponents = {
  "/": Home,
  "/about": About,
  "/products": Products,
  "/applications": Applications,
  "/export-sourcing": ExportSourcing,
  "/contact": Contact
};

export default function App() {
  const path = normalizePath(withoutBase(window.location.pathname));
  const Page = pageComponents[path] || Home;

  return (
    <>
      <SEO path={path} />
      <Header currentPath={path} />
      <main>
        <Page />
      </main>
      <FloatingWhatsApp />
      <Footer />
    </>
  );
}
